export default __webpack_public_path__ + "static/media/fo.4348c39a.svg";